import { Component } from "react";
import type { ReactNode } from "react";

type Props = {
  children: ReactNode;
  /** Rendered instead of `children` once a descendant throws. */
  fallback: ReactNode;
};

/**
 * Minimal, reusable error boundary for graceful degradation of a self-contained
 * section (e.g. an embedded video that may 404 while still transcoding). It does
 * NOT report to Sentry — these are expected, locally-handled absences. To reset
 * it when the underlying input changes, give it a `key` (e.g. `key={data.id}`).
 */
class ErrorBoundary extends Component<Props, { hasError: boolean }> {
  state = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  render() {
    return this.state.hasError ? this.props.fallback : this.props.children;
  }
}

export default ErrorBoundary;
